import React from "react";

// État vide d'une carte ; `erreur` : variante d'échec de chargement, en
// `danger-ink` et annoncée (`role="alert"`), avec en général « Réessayer ».
const EmptyState = ({ icon = "fa-inbox", title, hint = null, action = null, erreur = false }) => (
  <div className={`empty-state${erreur ? " empty-state--error" : ""}`} role={erreur ? "alert" : undefined}>
    <i className={`fa ${icon}`} aria-hidden="true" />
    <span className="empty-state__title">{title}</span>
    {hint && <small className="empty-state__hint">{hint}</small>}
    {action && (
      <div className="empty-state__action">
        <button type="button" className="btn btn-sm btn-outline-primary" onClick={action.onClick}>
          {action.label}
        </button>
      </div>
    )}
  </div>
);

export default EmptyState;
